import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { supabase } from '../../lib/supabase';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FeaturesGrid from './components/FeaturesGrid';
import Footer from './components/Footer';

const LandingPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const [showVerificationToast, setShowVerificationToast] = useState(false);

  // Handle legacy payment success callback (old Iyzico redirect pattern)
  useEffect(() => {
    const status = searchParams?.get('status');
    
    if (status === 'payment_success') {
      console.log('✅ Payment successful - clearing cart and redirecting to success page');
      localStorage.removeItem('cartItems');
      clearCart();
      navigate('/checkout-success', { replace: true });
    }
  }, [searchParams, clearCart, navigate]);

  // Detect email verification success from URL hash
  useEffect(() => {
    const hash = window.location?.hash;
    if (hash && hash?.includes('type=signup') && hash?.includes('access_token')) {
      // Let Supabase process the tokens from the hash to establish the session
      supabase?.auth?.getSession()?.then(({ data: { session } }) => {
        // Clean the hash from URL without reload (after Supabase has read it)
        window.history?.replaceState(null, '', window.location?.pathname + window.location?.search);
        
        if (session?.user) {
          // Session established — show success toast
          setShowVerificationToast(true);
          const timer = setTimeout(() => {
            setShowVerificationToast(false);
          }, 2000);
          return () => clearTimeout(timer);
        }
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <HeroSection />
      <FeaturesGrid />
      <Footer />

      {/* Email Verification Success Toast */}
      {showVerificationToast && (
        <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 flex items-center gap-3 bg-green-600 text-white px-6 py-4 rounded-xl shadow-2xl animate-fade-in-down">
          <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <div>
            <p className="font-semibold text-sm">E-posta doğrulandı!</p>
            <p className="text-xs text-green-100">Hesabınız doğrulandı ve giriş yapıldı.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;